import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { Carousel } from "react-bootstrap"
import { Link } from "gatsby"
import "/src/styles/HeroSliderStyle.css"

const Heroslider = () => {
  return (
    <div className="csicon-hero-slider">
      <Carousel fade interval={null} className="main-carousel">
        {/* Slide 1 */}  
        <Carousel.Item className="carousel-cell">
          <StaticImage
            src="../assets/slider_2026/Slider_1.png"
            className="img-slide"
            layout="fullWidth"
            loading="eager"
            placeholder="blurred"
            alt="CSICon 2026 in Buffalo, NY"
            quality={100}
            formats={["auto", "webp", "png"]}
            output="webp"
          />
          <Carousel.Caption className="slide-title">
            <h2>
              <span>CSICon 2026: June 11-14, Buffalo, NY</span>
              <br />
              <span>Downtown Buffalo Convention Center</span>
            </h2>
            <div className="slide-cta">
            <a className="slide-cta-btn" href="/registration">
          Celebrate Our History...Chart Our Future
        </a>
            </div>
          </Carousel.Caption>
        </Carousel.Item>
        
        {/* Slide 2 */}  
        <Carousel.Item className="carousel-cell">
          <StaticImage
            src="../assets/slider_2026/Slider_2b_nologo.png"
            className="img-slide"
            layout="fullWidth"
            loading="eager"
            placeholder="blurred"
            alt="CSICon 2026 Featured Guests"
            quality={100}
            formats={["auto", "webp", "png"]}
            output="webp"
          />
          <Carousel.Caption className="slide-title">
            <h2>
              <span>Get to Know Our Featured Guests</span>
            </h2>
            <div className="slide-cta">
              <a className="slide-cta-btn" href="#Speakers">
                Bill Nye, Banachek, The Skeptics' Guide podcast crew, and more!
              </a>
            </div>
          </Carousel.Caption>
        </Carousel.Item>
        
        {/* Slide 3 */}  
        <Carousel.Item className="carousel-cell">
          <StaticImage
            src="../assets/slider_2026/Slider_3.png"
            className="img-slide"
            layout="fullWidth"
            loading="eager"
            placeholder="blurred"
            alt="CSICon 2026 Hotel Information"
            quality={100}
            formats={["auto", "webp", "png"]}
            output="webp"
          />
          <Carousel.Caption className="slide-title">
            <h2>
              <span>Special Discounted Room Rates</span>
            </h2>
            <div className="slide-cta">
              <Link to="/hotel" className="slide-cta-btn">
                Reserve your room at the Hyatt Regency Buffalo
              </Link>
            </div>
          </Carousel.Caption>
        </Carousel.Item>
        
        {/* Slide 4 */}  
        <Carousel.Item className="carousel-cell">
          <StaticImage
            src="../assets/slider_2026/Slider_4.png"
            className="img-slide"
            layout="fullWidth"
            loading="eager"
            placeholder="blurred"
            alt="CSICon 2026 Side Quests and Activities"
            quality={100}
            formats={["auto", "webp", "png"]}
            output="webp"
          />
          <Carousel.Caption className="slide-title">
            <h2>
              <span>CSICon 2026 'Side Quests'</span>
            </h2>
            <div className="slide-cta">
              <Link to="/more-to-do" className="slide-cta-btn">
                More at CSICon!
              </Link>
            </div>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </div>
  )
}

export default Heroslider